import React from 'react'
import * as ROUTES from 'constant/routes'
import { UserOutlined, LayoutOutlined, AppstoreOutlined, FolderOutlined, QuestionCircleOutlined, TagOutlined } from '@ant-design/icons'

export const ADMIN_MENU_GROUPS = [
  {
    icon: <UserOutlined />,
    key: ROUTES.USER_MANAGEMENT,
    navName: 'UAM',
    onlyAdmin: true
  },
  {
    icon: <AppstoreOutlined />,
    key: ROUTES.SITE_MANAGEMENT,
    navName: 'Sites'
  },
  {
    icon: <LayoutOutlined />,
    key: ROUTES.CATEGORY_MANAGEMENT,
    navName: 'Categories'
  },
  {
    icon: <TagOutlined />,
    key: ROUTES.TAG_MANAGEMENT,
    navName: 'Tags'
  },
  {
    icon: <FolderOutlined />,
    items: [
      {
        key: ROUTES.WEBPAGE_MANAGEMENT,
        navName: 'Bespoke Web Pages'
      },
      {
        key: ROUTES.DATASET_MANAGEMENT,
        navName: 'DataSets'
      },
      {
        key: ROUTES.DISCOVERY_MANAGEMENT,
        navName: 'Discoveries'
      },
      {
        key: ROUTES.INSIGHT_MANAGEMENT,
        navName: 'Insights'
      }
    ],
    title: 'Assets'
  },
  {
    icon: <QuestionCircleOutlined />,
    key: ROUTES.HELP_MANAGEMENT,
    navName: 'Help',
    onlyAdmin: true
  }
]

export const HOME_MENU_ITEM = {
  key: ROUTES.HOME,
  navName: 'Home'
}

export const ADMIN_MENU_ITEM = {
  key: ROUTES.USER_MANAGEMENT,
  navName: 'Administration'
}
